import lazy from "../lazy";
import { DefaultOnEndReachedThreshold } from "./constants";
import { ListProps } from "./types";

const LazyFlashList = lazy(() => import("@shopify/flash-list").then((m) => m.FlashList));
const List = ({
	WebListComponent: ListComponent,
	animatedRef,
	onEndReachedThreshold = DefaultOnEndReachedThreshold,
	...props
}: ListProps<unknown>) => {
	if (ListComponent)
		return (
			<ListComponent
				{...props}
				onEndReachedThreshold={onEndReachedThreshold}
				// @ts-expect-error
				ref={animatedRef}
			/>
		);
	return <LazyFlashList {...props} onEndReachedThreshold={onEndReachedThreshold} />;
};
export default List;
